import { createContext, Dispatch, SetStateAction } from "react";
import { Property } from "../../../interface/tracker";
import { IUserProfileDetails } from "../../../interface/userdetails";

interface AddPropertyContextType {
  property: Partial<Property>;
  setProperty: Dispatch<SetStateAction<Partial<Property>>>;
  userProfile: IUserProfileDetails | undefined;
  setUserProfile: Dispatch<SetStateAction<IUserProfileDetails | undefined>>;
}

export const AddPropertyContext = createContext<AddPropertyContextType | undefined>(undefined);
